import { getAPIFromDomain } from "../../lib/api";

export const fetchAndDownloadCsvTemplate = async ({ key, node }: { key: string; node: HTMLElement }) => {
  try {
    const api = getAPIFromDomain("fulfillment");
    const file = `${key}.csv`;
    const res = await api.get(`/csv_templates/${file}`, {
      responseType: "blob",
    });

    downloadCsv({ blobPart: res.data, filename: file });
  } catch {
    throw new Error("Oops, something went wrong.");
  }
};

export const downloadCsv = async ({ blobPart, filename }: { blobPart: BlobPart; filename: string }) => {
  const blob = new Blob([blobPart], { type: "application/csv" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  link.dispatchEvent(
    new MouseEvent(`click`, {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );
  link.remove();
};
